module.exports = __webpack_public_path__ + "static/media/interior4.767be823.png";